// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3EXwM","dragIcon":"SortableItem_dragIcon__jXTds","disabled":"SortableItem_disabled__piPuU"};